import { memo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';



// Edited Functionality of re-arranging dashboard menu with two ways binding --Shuaib Peerjade 04/10/2024 ---START

const SubNav = ({ handleToggle, activeNav, arrMemoisedMenus, ...props }) => {

    const objLoginSession = useSelector(state => state.auth.objLoginSession);

    return (
        <Container fluid className='p-0 position-relative dashboard-subnav'>
            <Row className='g-0 align-items-center subnav-container'>
                {/* <Col md={2}>
                    <BzToolTip placement='bottom' TooltipMsg={objLoginSession?.data?.user_name} >
                        <div className='font-regular font-size6 color-text text-truncate'>Hi, <span className='font-medium'>{objLoginSession?.data?.user_name ? objLoginSession?.data?.user_name?.length > 1 ? objLoginSession?.data?.user_name?.slice(0, 15) + ".." : objLoginSession?.data?.user_name : ''}</span></div>
                    </BzToolTip>
                </Col> */}
                <Col md={12}>
                    <div className='submenu-wrapper horizontal-scroll-wrap text-center p-2'>
                        {
                            arrMemoisedMenus?.length && arrMemoisedMenus.map((item, index) => {
                                return <a data-testid={item?.name} key={index} href={`#${item?.name}`} onClick={handleToggle.bind(this, item.name)}
                                    className={`submenuItem ${activeNav === item?.name ? 'active' : ''}`}>{item.displayName}</a>;
                            })
                        }
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default memo(SubNav);

// Edited Functionality of re-arranging dashboard menu with two ways binding --Shuaib Peerjade 04/10/2024 ---END